

import { Badge, Callout, Card, Flex, Tabs, Text } from '@radix-ui/themes';
import { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Lists } from '../../../components/common/Lists';
import TableComponent from '../../../components/common/Tables';
import { useAppDispatch } from '../../../hooks/hooks';
import { useGetPaymentReferencesQuery } from '../../../hooks/useGetPaymentReferencesQuery';
import { useGetStudentDebtiesQuery, useGetStudentDebtsTotalByStudentIdQuery } from '../../../hooks/useGetStudentDebtiesQuery';
import { useGetTeacheIdByUserId } from '../../../hooks/useGetTeacheIdByUserId';
import { RootState } from '../../../redux/store';
import { routes } from '../../../routes';
type ActiveSegmentTab = 'totalStudentDebts' | 'studentDebts' | 'paymentReferences' | 'payed';
const columnNamesMapStudentDebt: { [key: string]: string } = {
  paymentType: "Tipo de pagamento",
  originalAmount: "Valor a pagar",
  currentAmount: "Valor remanescente",
  dueDate: "Ate data a pagar",
  description: "Descrição",
  isPayedIcon: "Pago ?",
};
const columnNamesMapPaymentReference: { [key: string]: string } = {
  paymentType: "Tipo de pagamento",
  referenceCode: "Ref.",
  entity: "Entidade",
  amount: "Valor",
  dueDate: "Ate data a pagar",
  isPayedIcon: "Pago ?",
};
export const GetStudentFinanceState = () => {
  const [activeSegment, setActiveSegment] = useState<ActiveSegmentTab>('totalStudentDebts');
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { UserId } = useSelector((state: RootState) => state.login.userData);
  const { data: studentData, isLoading: isLoadingStudentData } = useGetTeacheIdByUserId(UserId);
  const [currentPageStudentDebt, setCurrentPageStudentDebt] = useState(1);
  const [currentPagePaymentReferences, setCurrentPagePaymentReferences] = useState(1);
  const { data: studentDebtsData, refetch: fetchStudentDebts, status: studentDebtsStatus } = useGetStudentDebtiesQuery({ PageNumber: 1, PageSize: 4000, IdStudent: studentData?.idStudent },
    {
      enabled: !!studentData?.idStudent
    }
  )
  const { data: paymentReferencesData, refetch: fetchPaymentReferences, status: paymentReferencesStatus } = useGetPaymentReferencesQuery({ PageNumber: 1, PageSize: 4000, IdStudent: studentData?.idStudent },
    {
      enabled: !!studentData?.idStudent
    }
  )
  const { data: studentDebtsTotalsData } = useGetStudentDebtsTotalByStudentIdQuery(studentData?.idStudent,
    {
      enabled: !!studentData?.idStudent
    }
  )
  const navigateAndValidate = (tabToNavigateTo: ActiveSegmentTab) => {
    if (activeSegment !== tabToNavigateTo) setActiveSegment(tabToNavigateTo);
    //trigger();
  }
  const studentDebtsNotPayed = studentDebtsData?.items.filter(sd => !sd.isPayed && sd.idStudent === studentData?.idStudent);
  const studentDebtsPayed = studentDebtsData?.items.filter(sd => sd.isPayed && sd.idStudent === studentData?.idStudent);
  const studentPaymentReferences = paymentReferencesData?.items.filter(sd => sd.idStudent === studentData?.idStudent);
  const totalDebts = studentDebtsTotalsData?.totalDebt;
  const handlePageChangeStudentDebt = (page: number) => {
    setCurrentPageStudentDebt(page);
  };
  const handlePageChangePaymentReference = (page: number) => {
    setCurrentPagePaymentReferences(page);
  };
  // const handleEdit = (c: StudentDebtType) => {
  //   c.isPayedIcon = '';

  //   if(c.currentAmount != c.originalAmount || c.isPayed){
  //     toast.error("Não pode editar Cobrança")
  //     return;
  //   }
  //   dispatch(setStudentDebtData(c));
  //   dispatch(setPreviousPath(routes.checkStudentDebtByStudent));
  //   navigate(routes.updateStudentDebt)

  // };
  //     const handlePayStudentDebt = async(c: StudentDebtType) => {
  //       if(c.isPayed){
  //         toast.success("Cobrança paga");
  //         return;
  //       } 
  //       try{
  //         let {items} = await getPaymentTransactions({PageSize: 4000, PageNumber:1, IdStudentDebt: c.id})
  //         items = items.filter(i=> i.idStudentDebt===c.id);
  //         c.isPayedIcon = '';
  //         c.paymentTransation = items;
  //         dispatch(setStudentDebtData(c));
  //         dispatch(setPreviousPath(routes.checkStudentDebtByStudent));
  //         navigate(routes.payStudentDebt)
  //       }catch{
  //         toast.error("Ops! Ocorreu um erro");
  //       }
  //     };
  //     const handleNotifyStudentDebt = (c: StudentDebtType) => {
  //       c.isPayedIcon = '';
  //       if(c.isPayed){
  //         toast.error("Cobrança paga, não será possivel notificar estudante");
  //         return;
  //       }
  //       dispatch(setPreviousPath(routes.checkStudentDebtByStudent));
  //       dispatch(setStudentDebtData(c));
  //     };
  //     const handleCheckPayments = async(c: StudentDebtType) => {
  //       c.isPayedIcon = '';
  //       try{
  //         let {items} = await getPaymentTransactions({PageSize: 4000, PageNumber:1, IdStudentDebt: c.id})
  //         items = items.filter(i=> i.idStudentDebt===c.id);
  //         c.isPayedIcon = '';
  //         c.paymentTransation = items;
  //         dispatch(setStudentDebtData(c));
  //         dispatch(setPreviousPath(routes.checkStudentDebtByStudent));
  //         navigate(routes.checkPayments)
  //       }catch{
  //         toast.error("Ops! Ocorreu um erro");
  //       }
  //     };

  //     const mutationUpdate = useMutation(updateStudentDebt, {
  //       onSuccess: () => {
  //           queryClient.invalidateQueries(Key_studentdebties);
  //           toast.success('Cobrança apagada');
  //       },
  //       onError: () => {
  //           toast.error("Erro ao apagar Cobrança")
  //       }
  //   });
  //   const openDeleteDialog = (c: StudentDebtType) => {
  //     if(c.isPayed){
  //       toast.error("Cobrança paga, não será possivel apagar");
  //       return;
  //     }
  //     if(c.currentAmount !=c.originalAmount){
  //       toast.error("Cobrança em pagamento, não será possivel apagar");
  //       return;
  //     }
  //     setDeleteItem(c);
  //   };  
  //   const handleDelete = (c: StudentDebtType) => {
  //     c.status = false;
  //     c.isPayedIcon = '';
  //     mutationUpdate.mutateAsync(c)
  //   };
  //   const confirmDelete = async () => {
  //     if (deleteItem) {
  //         await handleDelete(deleteItem!)
  //     }
  //   };
  const optionsStudentDebts =
    // studentDebtsNotPayed?.map((c: StudentDebtType) => [
    //   {
    //       label: 'Editar',
    //       onClick: () => handleEdit(c),
    //       icon: <Pencil1Icon />
    //   },
    //   {
    //       label: 'Pagar',
    //       onClick: () => handlePayStudentDebt(c),
    //       icon: <Pencil1Icon />
    //   },
    //   {
    //       label: 'Transações de pagamento',
    //       onClick: () => handleCheckPayments(c),
    //       icon: <Pencil1Icon />
    //   },
    //   {
    //       label: 'Notificar Cobrança',
    //       onClick: () => handleNotifyStudentDebt(c),
    //       icon: <BellIcon />
    //   },
    //   {
    //       label: 'Excluir',
    //       onClick: () => openDeleteDialog(c),
    //       icon: <TrashIcon />
    //   }
    // ]) ||
    [];

  if (!studentData || !studentData.idStudent) {
    return (
      <Flex direction="column">
        <Callout.Root color="red" role="alert">
          <Text>
            Entre como estudante &nbsp;
            <Link to={routes.dashboard} style={{ color: 'var(--gray-12)' }}>Voltar</Link>
          </Text>
        </Callout.Root>

      </Flex>
    );
  }

  return (
    <Card size='1'>
      <Flex direction='column' gap='4'>
        <Tabs.Root value={activeSegment}
          onValueChange={(tabToNavigate) => {
            navigateAndValidate(tabToNavigate as ActiveSegmentTab);
          }}
        >
          <Tabs.List>
            <Tabs.Trigger value="totalStudentDebts">Total em dividas</Tabs.Trigger>
            <Tabs.Trigger value="payed">Pagamentos</Tabs.Trigger>
            <Tabs.Trigger value="studentDebts">Cobranças</Tabs.Trigger>
            <Tabs.Trigger value="paymentReferences">Referências</Tabs.Trigger>
          </Tabs.List>
          <Tabs.Content value="totalStudentDebts">
            <Flex style={{ padding: '2%' }}>
              Cobranças:  <Text color='red' style={{ marginLeft: '4px' }}>
                {
                  totalDebts?.toFixed(2)
                }Mtn
              </Text>
            </Flex>
          </Tabs.Content>
          <Tabs.Content value="payed">
            <>
              <Lists
                status={studentDebtsStatus}
                TableComponent={() =>
                  <TableComponent
                    columns={Object.keys(columnNamesMapStudentDebt)}
                    items={studentDebtsPayed?.map(item => {
                      return {
                        ...item,
                        isPayedIcon: item.isPayed ? <><Badge color="green">
                          Pago
                        </Badge> </> :
                          <Badge color="red">
                            Não pago
                          </Badge>
                      }
                    })}
                    options={[]}
                    columnNamesMap={columnNamesMapStudentDebt}
                    totalPages={studentDebtsPayed?.length || 1}
                    currentPage={currentPageStudentDebt}
                    onPageChange={handlePageChangeStudentDebt}
                  />
                }
                handleClickCreate={undefined}
              />
            </>
          </Tabs.Content>
          <Tabs.Content value="studentDebts">
            <>
              <Lists
                status={studentDebtsStatus}
                TableComponent={() =>
                  <TableComponent
                    columns={Object.keys(columnNamesMapStudentDebt)}
                    items={studentDebtsNotPayed?.map(item => {
                      return {
                        ...item,
                        isPayedIcon: item.isPayed ? <><Badge color="green">
                          Pago
                        </Badge> </> :
                          <Badge color="red">
                            Não pago
                          </Badge>
                      }
                    })}
                    options={[]}
                    columnNamesMap={columnNamesMapStudentDebt}
                    totalPages={studentDebtsNotPayed?.length || 1}
                    currentPage={currentPageStudentDebt}
                    onPageChange={handlePageChangeStudentDebt}
                  />
                }
                handleClickCreate={undefined}
              />
            </>
          </Tabs.Content>
          <Tabs.Content value="paymentReferences">
            <Lists
              status={paymentReferencesStatus}
              TableComponent={() =>
                <TableComponent
                  columns={Object.keys(columnNamesMapPaymentReference)}
                  items={studentPaymentReferences?.map(item => {
                    return {
                      ...item,
                      isPayedIcon: item.isPayed ? <><Badge color="green">
                        Pago
                      </Badge> </> :
                        <Badge color="red">
                          Não pago
                        </Badge>
                    }
                  })}
                  options={[]}
                  columnNamesMap={columnNamesMapPaymentReference}
                  totalPages={studentPaymentReferences?.length || 1}
                  currentPage={currentPagePaymentReferences}
                  onPageChange={handlePageChangePaymentReference}
                />
              }
              handleClickCreate={undefined}
            />
          </Tabs.Content>
        </Tabs.Root>
      </Flex>
    </Card>
  )
}

